import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NbContextMenuDirective, NbMenuItem, NbMenuService, NbPosition } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { IFile } from '@shared/interfaces/file/file';
import { filter, Subscription } from 'rxjs';
import { FileDisplayType } from '../../enums/file-display-type.enum';

@Component({
  selector: 'app-file-browser-file',
  templateUrl: './file-browser-file.component.html',
  styleUrls: ['./file-browser-file.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileBrowserFileComponent implements OnInit {
  @ViewChild(NbContextMenuDirective) contextMenu: NbContextMenuDirective;

  @Input() file!: IFile;
  @Input() previewTemplate: TemplateRef<any>;
  @Input() infoTemplate: TemplateRef<any>;
  @Input() displayType: FileDisplayType;
  @Input() multiSelect: boolean;
  @Input() disabled: boolean;

  @Input() enableUnlock: boolean;
  @Input() enableShare: boolean;
  @Input() enablePrint: boolean;
  @Input() enableDelete: boolean;
  @Input() enableDownload: boolean;

  @Output() onPrint = new EventEmitter<IFile>();
  @Output() onUnlock = new EventEmitter<IFile>();
  @Output() onShare = new EventEmitter<IFile>();
  @Output() onDownload = new EventEmitter<IFile>();
  @Output() onDelete = new EventEmitter<IFile>();
  @Output() onNext = new EventEmitter<IFile>();

  @Input() selected: boolean;
  @Output() selectedChange = new EventEmitter<boolean>();

  protected placement = NbPosition.TOP;
  protected actions: NbMenuItem[] = [];
  protected readonly componentID = Math.random();
  protected readonly displayTypes = FileDisplayType;

  private isMenuOpen = false;
  private subscription = new Subscription();
  
  constructor(
    private nbMenuService: NbMenuService,
    private translateService: TranslateService
  ) { }

  protected get previewBlocksEnabled(): boolean {
    return this.displayType === FileDisplayType.PREVIEW_BLOCKS;
  }

  ngOnInit(): void {
    this.enablePrint && this.file.isAvailableToPrint && this.actions.push({ icon: 'play-circle-outline', title: this.translateService.instant('common.print-file'), data: 'onPrint' });
    this.enableUnlock && this.actions.push({ icon: 'unlock-outline', title: this.translateService.instant('common.unlock'), data: 'onUnlock' });
    this.enableDownload && this.actions.push({ icon: 'download-outline', title: this.translateService.instant('common.download'), data: 'onDownload' });
    this.enableDelete && !this.file.isFixed && this.actions.push({ icon: 'trash-2-outline', title: this.translateService.instant('common.delete'), data: 'onDelete' });

    this.subscription.add(
      this.nbMenuService
        .onItemClick()
        .pipe(filter(data => data.tag === `${this.componentID}-${this.file.id}`))
        .subscribe(data => this[data.item.data].next(this.file))
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  protected switchMenu(): void {
    this.isMenuOpen ? this.contextMenu.hide() : this.contextMenu.show();
    this.isMenuOpen = !this.isMenuOpen;
  }

  protected hideMenu(): void {
    // Set timeout so the click gets handled before catching blur
    setTimeout(() => {
      this.contextMenu?.hide();
      this.isMenuOpen = false;
    }, 1000);
  }
}
